// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2JNGs","vLegacy":"SelectSecondary_vLegacy__2yP_K","error":"SelectSecondary_error__2r1Sx","disabled":"SelectSecondary_disabled__2-dbx"};